import { useAppContext } from '../../appProvider/contextProvider';



const Overlay = ({
    title,
    titleColor,
    message,
    messageColor,
    allowBtnText,
    allowBtnTextColor,
    allowBtnColor,
    denyBtnText,
    denyBtnTextColor,
    denyBtnColor,
    background,
}) => {
    const {selectedWebsite} = useAppContext();
    return  <div className="prompt-alert text-center" data-mobile-alert="overlay" style={{background: background}}>                                                        
        <div className="custom-description px-3">
            <h6 className="ml-2 mt-2 break-heading" style={{color: titleColor}}>{title}</h6>
            <p className="mb-3 text-light"><small style={{color: messageColor}}>{message}</small></p>
            {selectedWebsite?.is_branding_enabled && <p className="text-light"><small>Powered by ChirpyWeb</small></p>}
        </div>
        <div className="full-width">                                                            
            <button className="btn btn-block btn-outline btn-allow mb-2" style={{background: denyBtnColor, color: denyBtnTextColor}}>{allowBtnText}</button>
            <button className="btn btn-block btn-outline btn-later" style={{background: allowBtnColor, color: allowBtnTextColor}}>{denyBtnText}</button>                                                    
        </div>                                                 
    </div>
}


export default Overlay;